import { FORMATTERS } from '../../utils/formatters';
import { GRAPH_UNIT_TYPES } from '../../consts/graphTypes';
import {
  getGranularityByDates,
  isMedianMetric
} from '../../../custom-report.util';
import capitalize from 'lodash/capitalize';
import {
  ISSUE_COUNT_CALCULATION_STRATEGY,
  METRICS_CALCULATION_STRATEGY_LABEL
} from '@linearb/linjs-common';

const getReportedMetricDescription = ({
  graph,
  filters: { selectedGranularity, selectedTimeRanges }
}) => {
  const unit = graph?.filters?.unit || '';
  const granularity = getGranularityByDates({
    selectedGranularity,
    ...selectedTimeRanges
  });
  return `${unit} per ${granularity}`;
};

const getDescription = ({
  graph: { metrics = [], unitType, unitDescription, overridePercentName },
  filters: { selectedGranularity, selectedTimeRanges },
  percentOffValue
}) => {
  const mainMetric = metrics[0];
  const percentOff = mainMetric?.percentOff;

  const granularity = getGranularityByDates({
    selectedGranularity,
    ...selectedTimeRanges
  });

  const percTotalValue =
    percentOff &&
    FORMATTERS[GRAPH_UNIT_TYPES.COUNT].avgFormatter(percentOffValue);

  const percDescription =
    percentOff?.name && percentOff?.name.toLocaleLowerCase();

  switch (unitType) {
    case GRAPH_UNIT_TYPES.COUNT:
      return `${unitDescription} ${granularity}`;
    case GRAPH_UNIT_TYPES.PERCENTAGE && !overridePercentName:
      return `${unitDescription} out of ${percTotalValue} ${percDescription}`;
    default:
      return unitDescription;
  }
};

export const getDescriptionPerMetric = ({
  graph,
  filters,
  isPmCustomDashboard,
  isReportedMetric,
  percentOffValue,
  metricsCalculationStrategy
}) => {
  const { metrics = [], calculation_strategy } = graph;
  const mainMetric = metrics[0];
  const metricName = mainMetric?.name;

  const shouldShowMedianLabel = isMedianMetric(metricName);

  const description = [
    ...(shouldShowMedianLabel
      ? [
          capitalize(
            METRICS_CALCULATION_STRATEGY_LABEL[
              graph.agg ?? metricsCalculationStrategy
            ]
          )
        ]
      : []),
    getDescription({
      graph,
      filters,
      percentOffValue
    })
  ].join(' ');

  const calculationStrategy =
    calculation_strategy ?? ISSUE_COUNT_CALCULATION_STRATEGY;

  const pmMetricDescription =
    calculationStrategy === ISSUE_COUNT_CALCULATION_STRATEGY
      ? 'Avg. issues'
      : 'Avg. story points';

  const reportedMetricDescription = getReportedMetricDescription({
    graph,
    filters
  });

  if (isPmCustomDashboard) {
    return pmMetricDescription;
  }
  if (isReportedMetric) {
    return reportedMetricDescription;
  }

  return description;
};
